// dndHelpers — DnD 관련 헬퍼 타입 및 유틸.
// - DnD data 타입 정의 (draggable / droppable)
// - 서버 에러 코드 → 한국어 토스트 메시지 변환

// ─── 드래그 데이터 타입 ─────────────────────────────────────

/**
 * useDraggable data.current 타입.
 * id 형식: "group-{id}" | "item-{id}"
 *
 * U45 멀티 드래그:
 * - item 타입에 selectedIds 추가.
 * - 드래그 시작 시 ItemCard가 DndProvider에서 조회한 선택 ids를 주입.
 * - selectedIds가 2개 이상이고 itemId가 그 안에 포함되면 DndProvider가 multi 모드로 처리.
 */
export type DndDraggableData =
  | {
      type: 'group';
      groupId: number;
      kind: string;
    }
  | {
      type: 'item';
      itemId: number;
      /** 멀티 선택 드래그 시 선택된 모든 id (단일 드래그면 [itemId]) */
      selectedIds: number[];
    };

/**
 * useDroppable data.current 타입.
 * id 형식: "group-{id}" | "root-{kind}"
 */
export type DndDroppableData =
  | {
      type: 'group';
      groupId: number;
      kind: string;
    }
  | {
      type: 'root';
      kind: string;
    };

// ─── 에러 코드 → 한국어 메시지 ─────────────────────────────

/**
 * 서버 DnD 관련 에러 코드를 사용자 친화적 한국어 메시지로 변환한다.
 * 알 수 없는 에러 코드는 fallback 메시지를 반환한다.
 */
export function dndErrorMessage(errorCode: string): string {
  switch (errorCode) {
    case 'group_cycle':
      return '자신의 자손으로 옮길 수 없습니다';
    case 'group_depth_exceeded':
      return '그룹 깊이가 5단을 초과합니다';
    case 'group_kind_mismatch':
      return '다른 카테고리의 그룹으로 옮길 수 없습니다';
    default:
      return '이동에 실패했습니다';
  }
}
